import getApiClient from '@/plugins/api-client'

export default {
  download: function () {
    const self = this,
      api = getApiClient(self.$store),
      parameters = {}

    self.filters['createdAt[before]'] = self.filters['month[before]']
    self.filters['createdAt[after]'] = self.filters['month[after]']
    Object.keys(self.filters).forEach(filter => {
      if (self.filters[filter]) {
        parameters[filter] = self.filters[filter]
      }
    })

    if (parameters['month[after]']) {
      parameters['from'] = `${parameters['month[after]']} 00:00:00`
      delete parameters['createdAt[after]']
      delete parameters['month[after]']
    }

    if (parameters['month[before]']) {
      parameters['to'] = `${parameters['month[before]']} 23:59:59`

      delete parameters['createdAt[before]']
      delete parameters['month[before]']
    }

    parameters['cnpj'] = self.filters.company?.value
    delete parameters['company']

    self.$store.state.loading = true
    api.get('/events/report/download', {responseType: 'blob', params: parameters})
      .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data])),
          link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'Relatório de eventos - Castfy.xlsx')
        document.body.appendChild(link)
        link.click()
      })
      .catch(() => {
      })
      .finally(() => {
        self.$store.state.loading = false
      })
  },

  formattedSearchDisplay(result) {
    return `${result.name} (${result.cnpj})`
  },

  setCompany(company) {
    this.filters.company = company
  }
}
